<template>
	<node-view-wrapper class="teaming-tiptap-decision rte-node--draggable">
		<div
			class="rte-node__drag-handle"
			contenteditable="false"
			draggable="true"
			data-drag-handle
		/>
		<div class="teaming-tiptap-decision__row">
			<div class="teaming-tiptap-decision__gavel">
				<FontAwesomeIcon
					:icon="[ 'fas', 'gavel' ]"
					class="teaming-tiptap-decision__icon"
				/>
			</div>
			<node-view-content class="teaming-tiptap-decision__content rte-node__content--draggable" />
		</div>
	</node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, NodeViewContent, nodeViewProps } from "@tiptap/vue-3";
import { TeamingTiptapExtensionType } from "@teaming/common-enums";

export default {
	name: "TeamingTiptapDecision",
	components: {
		NodeViewWrapper,
		NodeViewContent,
	},

	props: nodeViewProps,

	unmounted() {
		this.extension?.options?.onTeamingExtensionCallback( { extension: TeamingTiptapExtensionType.DECISION, type: "destroy", } );
	},
};
</script>

<style lang="scss">
.teaming-tiptap-decision {
	width: 100%;

	.rte-node__drag-handle {
		transform: translateY(10%);
	}
}

.teaming-tiptap-decision__row {
	width: 100%;
	display: flex;
	@include font-and-line-for(0);
	font-weight: 700;
	color: $tiptap-decision-font-color;
}

.teaming-tiptap-decision__gavel {
	margin-right: 0.625rem;
}

.teaming-tiptap-decision__content {
	flex-grow: 1;
}

.teaming-tiptap-decision__icon {
	color: $tiptap-decision-icon-color;
}
</style>
